import { Create, useForm } from '@refinedev/antd';
import { IExperienceEvent } from '../../../interfaces/experience';
import { Form, Input, Select } from 'antd';

export const ExperienceEventCreate = () => {
  const { formProps, saveButtonProps } = useForm<IExperienceEvent>({
    resource: 'experienceEvents',
  });

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="名前(管理用)" name="name">
          <Input />
        </Form.Item>
      </Form>
    </Create>
  );
};
